<script setup lang="ts">
import { useUiStore } from '@/store/uiStore';

const uiStore = useUiStore();
</script>

<template>
  <div class="confirmation-layer">
    <transition name="fade">
      <div v-if="!!uiStore.unlockFn" class="confirmation-background">
        <UiUnlockModal />
      </div>
    </transition>
  </div>
</template>

<style scoped lang="scss">
.confirmation-background {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(50, 50, 50, 0.8);
  z-index: 300;
  justify-content: center;
  align-items: center;
}
</style>
